var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 100,
    viewBox: "0 0 200 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.694 57.2735C183.993 57.2715 183.298 57.4079 182.649 57.6749C182 57.9419 181.411 58.3342 180.914 58.8294C180.417 59.3246 180.022 59.913 179.753 60.5608C179.484 61.2086 179.345 61.9032 179.344 62.6047C179.332 63.5102 179.56 64.4027 180.006 65.1917L184.657 74.5497C184.657 74.5497 188.471 66.9877 189.364 65.1917C189.81 64.3788 190.038 63.4637 190.024 62.5363C190.01 61.6089 189.754 60.7012 189.283 59.9022C188.812 59.1032 188.142 58.4405 187.337 57.9791C186.533 57.5177 185.622 57.2735 184.694 57.2705V57.2735ZM184.694 60.8276C185.049 60.8295 185.394 60.9362 185.688 61.1344C185.982 61.3326 186.21 61.6134 186.344 61.9412C186.479 62.2691 186.513 62.6294 186.442 62.9766C186.372 63.3239 186.2 63.6425 185.949 63.8922C185.697 64.1419 185.377 64.311 185.028 64.3779C184.68 64.4449 184.32 64.4068 183.993 64.2683C183.666 64.1303 183.388 63.8985 183.193 63.6024C182.999 63.3063 182.896 62.9591 182.898 62.6047C182.903 62.1314 183.094 61.679 183.43 61.3461C183.767 61.0132 184.221 60.8268 184.694 60.8276Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6962 46.0251C31.8366 45.1322 32.326 44.3317 33.0566 43.7996C33.7872 43.2675 34.6993 43.0475 35.5922 43.1879C36.485 43.3282 37.2856 43.8176 37.8177 44.5482C38.3497 45.2788 38.5698 46.1909 38.4294 47.0838C38.289 47.9767 37.7997 48.7772 37.0691 49.3093C36.3384 49.8414 35.4264 50.0614 34.5335 49.921C33.6406 49.7806 32.8401 49.2913 32.308 48.5607C31.7759 47.83 31.5558 46.918 31.6962 46.0251Z",
    fill: "#00C707"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.885 60.79C129.133 61.7731 130.361 62.7751 131.552 63.7581",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.946 70.6396C149.89 78.4663 159.946 84.2891 174.902 81.6613",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.9 10.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.197 80.4321C181.708 79.9981 183.201 79.5062 184.674 78.9575",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0436 64.7979C27.4146 65.5709 28.8284 66.2652 30.2784 66.8774",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3547 69.184C62.8716 69.7133 73.5738 37.3151 102.587 46.479C105.415 47.3702 108.174 48.4632 110.845 49.7496",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.44 10.44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.423 52.1694C116.803 52.9654 118.145 53.7953 119.449 54.646",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.694 57.2739C183.802 57.2716 182.923 57.4927 182.138 57.9172C181.353 58.3417 180.686 58.956 180.199 59.7041C179.713 60.4522 179.421 61.3103 179.351 62.2001C179.281 63.0898 179.434 63.983 179.798 64.7981L184.657 74.5491C184.657 74.5491 188.475 66.9871 189.364 65.1912C189.81 64.3785 190.038 63.4636 190.024 62.5365C190.009 61.6093 189.754 60.7018 189.283 59.9031C188.812 59.1045 188.141 58.4421 187.337 57.9811C186.532 57.5202 185.622 57.2764 184.694 57.2739Z",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.694 60.8277C184.219 60.8239 183.762 61.0089 183.424 61.3421C183.085 61.6752 182.893 62.1293 182.889 62.6043C182.885 63.0793 183.07 63.5363 183.403 63.8749C183.737 64.2135 184.191 64.4059 184.666 64.4097C185.141 64.4135 185.598 64.2285 185.936 63.8953C186.275 63.5621 186.467 63.1081 186.471 62.6331C186.475 62.1581 186.29 61.701 185.957 61.3625C185.623 61.0239 185.169 60.8315 184.694 60.8277Z",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7073 60.5822L33.4733 49.5605",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6962 46.0251C31.8366 45.1322 32.326 44.3317 33.0566 43.7996C33.7872 43.2675 34.6993 43.0475 35.5922 43.1879C36.485 43.3282 37.2856 43.8176 37.8177 44.5482C38.3497 45.2788 38.5698 46.1909 38.4294 47.0838C38.289 47.9767 37.7997 48.7772 37.0691 49.3093C36.3384 49.8414 35.4264 50.0614 34.5335 49.921C33.6406 49.7806 32.8401 49.2913 32.308 48.5607C31.7759 47.83 31.5558 46.918 31.6962 46.0251Z",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6081 19.6427C89.1703 13.7584 95.6437 14.7521 98.4703 15.7864C100.381 16.487 101.353 18.2565 99.5316 18.9571C90.9807 22.418 82.6591 26.4446 74.6198 31.0113C65.9077 35.9455 59.9576 41.266 53.9825 39.731C50.0431 38.4742 50.5179 38.4456 50.5179 38.4456C51.396 37.3663 52.4206 36.4211 53.5606 35.6388C54.2867 35.5291 55.7948 35.5817 56.521 35.5245C60.4404 31.5132 64.7129 27.8797 69.2841 24.67",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 20.6362C73.2383 18.4036 66.1862 16.5479 59.3879 15.1091C57.2865 14.6635 55.715 15.6537 53.5 16.7972C59.6025 19.7775 65.6593 22.8455 71.6682 26",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 16C89.1082 16.8035 89.8713 17.3958 90.7152 17.7196C91.5591 18.0434 92.4553 18.0876 93.3168 17.848C95.0305 17.3038 96.7594 16.8383 98.5 16.4525",
    stroke: "#7B828E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.27 26L154.5 33.07L159.86 32.12L158.09 39.19",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.47 72L94.13 75.73",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102 77.9702L98.27 78.6302",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.03 86.4998L95.37 82.7798",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 80.5301L91.23 79.8701",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.27 78.63C97.81 78.71 97.33 78.7 96.87 78.6C96.41 78.5 95.98 78.31 95.59 78.04C95.21 77.77 94.88 77.43 94.63 77.03C94.38 76.63 94.21 76.19 94.13 75.73C94.21 76.19 94.2 76.67 94.1 77.13C94 77.59 93.81 78.02 93.54 78.41C93.27 78.8 92.93 79.12 92.53 79.38C92.13 79.63 91.69 79.8 91.23 79.89C91.69 79.81 92.17 79.82 92.63 79.92C93.09 80.02 93.52 80.21 93.91 80.48C94.3 80.75 94.62 81.09 94.88 81.49C95.13 81.89 95.3 82.33 95.38 82.79C95.3 82.33 95.31 81.85 95.41 81.39C95.51 80.93 95.7 80.5 95.97 80.11C96.24 79.73 96.58 79.4 96.98 79.14C97.38 78.89 97.82 78.72 98.28 78.63H98.27Z",
    stroke: "#7B828E",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightImg);
export default __webpack_public_path__ + "static/media/flight-img.675d20ec17be2209c7bf7102b905bdc9.svg";
export { ForwardRef as ReactComponent };